// @ts-nocheck
/* eslint-disable */
export const compareIcon = {
    data: `<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.33333 2.5H4.16667C3.25 2.5 2.5 3.25 2.5 4.16667V15.8333C2.5 16.75 3.25 17.5 4.16667 17.5H8.33333V19.1667H10V0.833334H8.33333V2.5ZM8.33333 15H4.16667L8.33333 10V15ZM15.8333 2.5H11.6667V4.16667H15.8333V15L11.6667 10V17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V4.16667C17.5 3.25 16.75 2.5 15.8333 2.5Z" fill="currentColor"/></svg>`,
    name: 'compare' as const
};